mod.modules.define("SiteHeader", function(fn) {

	var searchLink = "",
		isOpen = null,
		$expandLink = null,
		$offerBox = null,
		$topSection = null,
		$proLibrary = null,
		$proLibraryLink = null;
		$collapsedStateCookie = "expandableHeaderState";

	fn.prototype.init = function(params) {
		isOpen = params.isOpen || false;

		var collapsedCookie = this.readCookie($collapsedStateCookie);

		if (collapsedCookie != null) {
			isOpen = false;
		}

		$expandLink = this.el.find("a.expandLink");
		$offerBox = this.el.find("div.offer-wrapper");
		$topSection = this.el.find("div.topSection");
		$proLibrary = this.el.find("div.proLibrary");
		$proLibraryLink = $proLibrary.find("a");
		searchLink = params.searchLink;
		this.el.find('span.underConstruction').tooltip();
	};

	fn.prototype.ToggleView = function() {
		var speed = 150;

		if (isOpen) {
			$offerBox.slideUp(speed);
			$topSection.switchClass("", "collapsed", speed);

			this.eraseCookie($collapsedStateCookie);
			this.createCookie($collapsedStateCookie, 1, 10000);
		}
		else {
			$offerBox.slideDown(speed);
			$topSection.switchClass("collapsed", "", speed);

			this.eraseCookie($collapsedStateCookie);
		}

		isOpen = !isOpen;
		this.ChangeText();
	}

	//Swaps the text for the expand/collapse link
	fn.prototype.ChangeText = function() {
		var altText = $expandLink.attr("data-alt-text");
		var currentText = $expandLink.text();

		$expandLink.attr("data-alt-text", currentText).text(altText);
	}

	fn.prototype.SiteSearch = function($el) {
		var $textInput = $el.find("input.textInput");
		var inputValue = $textInput.val();
		var defaultText = $textInput.attr("data-default-text")

		if (inputValue != "" && inputValue != defaultText) {
			if (searchLink) {
				window.location = searchLink + encodeURI(inputValue);
			}
			else {
				window.location = "http://www.valueline.com/Search/index.aspx?cx=010117891458446851464%3Asdbcf4jkowe&cof=FORID%3A11&ie=UTF-8&q=" + encodeURI(inputValue);
			}
		}
	}

	fn.prototype.events = {
		"a.expandLink": {
			"click": function(e, $el) {
				this.ToggleView();
			}
		},
		"form#siteSearch": {
			submit: function(evt, $el) {
				evt.preventDefault();
				this.SiteSearch($el);
			}
		},
		"form#quoteSearch": {
			submit: function(evt, $el) {
				evt.preventDefault();
				this.SiteSearch($el);
			}
		}
	};


	fn.prototype.createCookie = function (name, value, days) {
		var expires = "";

		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = "; expires=" + date.toGMTString();
		} else {
			var expires = "";
		}

		document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
	};

	fn.prototype.readCookie = function (name) {
		var nameEQ = escape(name) + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return unescape(c.substring(nameEQ.length, c.length));
		}
		return null;
	};

	fn.prototype.eraseCookie = function (name) {
		this.createCookie(name, "", -1);
	};
});